export default __webpack_public_path__ + "static/fee-mua-605b4def2db16cc668233be3ea7aadf1.jpg";